import { EnumHelper } from "@/Common/Helpers/EnumHelper";
import { WeightUnit } from "@/Common/Utilities/Units/Units";
import { ObstetricsCalculator } from "@/Patient/Helpers/ObstetricsCalculator";
import { IQuebecObstetricalFileFormPage } from "../IQuebecObstetricalFileFormPage";
import { EstimatedDateOfConfinementMethod } from "./EstimatedDateOfConfinementMethodEnum";
import { PrenatalVisit } from "./PrenatalVisit";

class QuebecObstetricalFileFormPageFour implements IQuebecObstetricalFileFormPage {
    public Summary: string;
    public Particularities: string;
    public WeightUnit: WeightUnit;
    public PrenatalVisits: PrenatalVisit[];
    public EstimatedDateOfConfinementMethod: EstimatedDateOfConfinementMethod;
    public EstimatedDateOfConfinementDateOfLastMenstruation: Date;
    public EstimatedDateOfConfinementClinicDate: Date;
    public EstimatedDateOfConfinementUltrasound20WeeksDate: Date;
    public EstimatedDateOfConfinementOtherUltrasound: Date;
    public Remarks: string;
    public IsReuseVitalSignOptionSet: boolean;

    constructor(fields?: Partial<QuebecObstetricalFileFormPageFour>) {
        Object.assign(this, fields);
        this.PrenatalVisits = fields?.PrenatalVisits?.map(visit => new PrenatalVisit(visit)) ?? [];
        this.WeightUnit = fields?.WeightUnit ?? WeightUnit.Kilogram;
    }

    public getChosenMethodEDCDate(): Date {
        switch (EnumHelper.getValue(EstimatedDateOfConfinementMethod, this.EstimatedDateOfConfinementMethod)) {
            case EstimatedDateOfConfinementMethod.DateOfLastMenstruation:
                return this.EstimatedDateOfConfinementDateOfLastMenstruation;

            case EstimatedDateOfConfinementMethod.ClinicDate:
                return this.EstimatedDateOfConfinementClinicDate;

            case EstimatedDateOfConfinementMethod.Ultrasound20WeeksDate:
                return this.EstimatedDateOfConfinementUltrasound20WeeksDate;

            case EstimatedDateOfConfinementMethod.OtherUltrasound:
                return this.EstimatedDateOfConfinementOtherUltrasound;

            default:
                return null;
        }
    }

    public updateWeeksOfGestation(contributionId: string): void {
        const expectedDueDate = this.getChosenMethodEDCDate();

        if (!!expectedDueDate) {
            this.PrenatalVisits = this.PrenatalVisits.mutate(
                p => p.WeeksOfGestation = ObstetricsCalculator.calculateWeeksOfGestation(expectedDueDate, p.Date),
                p => p.ContributionId === contributionId
            );
        }
    }

    public setWeightUnit(unit: WeightUnit): void {
        if (this.WeightUnit === unit)
            return;

        this.WeightUnit = unit;
        this.PrenatalVisits.forEach(p => p.WeightUnit = unit);
    }
}

export { QuebecObstetricalFileFormPageFour };
